import {useForm} from "react-hook-form";
import {useEffect, useState} from "react";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {setValidationMessage} from "../../../util/validationMessage";
import Modal from "../../../components/UI/Modal";
import Input from "../../../components/UI/form/Input";
import Button from "../../../components/UI/Button";
import { storeShippingMethod, updateShippingMethod} from "../../../api/shippingMethods";
import Select from "../../../components/UI/form/Select";
import RadioBox from "../../../components/UI/form/RadioBox";
import {getCarriers} from "../../../api/couriers";

const ShippingMethodFormComponent = ({editRecord = null, openModal, setOpenModal}) => {
  const {setValue, reset, register, setError, handleSubmit, formState: { errors }} = useForm({
    defaultValues:{
      status: '1',
      international: '0',
      domestic: '0',
    }
  });

  useEffect(() => {
    reset();
    if (editRecord) {
      Object.keys(editRecord).forEach(key => {
        setValue(key, editRecord[key]);
      });
    }
  }, [openModal, editRecord]);


  const queryClient = useQueryClient();
  const [toastId, setToastId] = useState(null);

  const {isPending, mutate} = useMutation({
    mutationFn: editRecord ? (data) => updateShippingMethod(editRecord.id, data) : storeShippingMethod,
    onMutate: () => {
      setToastId(toast.loading("Please wait..."))
    },
    onSuccess: (res) => {
      toast.update(toastId, { render: `Shipping Method ${editRecord ? 'Updated' : 'Added'}`, type: "success", isLoading: false, autoClose: true });
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'shipping-methods',
      });
      setOpenModal(false)
      reset();
    },
    onError: (error) => {
      let errorMsg = "Something happened!";
      if (error && error.message && error.message.errors) {
        setValidationMessage(error.message.errors, setError);
        errorMsg = error.message.message;
      }

      toast.update(toastId, { render: errorMsg, type: "error", isLoading: false, autoClose: true });
    }
  });

  const onSubmit = (data) => {
    mutate(data)
  }

  const {data: couriers} = useQuery({
    queryKey:['carriers'],
    queryFn: () => getCarriers()
  })

  return(
    <>
      <Modal title={`${editRecord ? 'Edit' : 'Add'} Shipping Method`} size={'modal_1080p'} open={openModal} setOpen={setOpenModal}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col_6 pr_20">
              <Input label="Name"
                     name="name"
                     inline={true}
                     errors={errors}
                     validationRules={{required: true, type: 'string'}}
                     register={register}/>
            </div>
            <div className="col_6 pr_20">
              <Input label="Code"
                     name="code"
                     inline={true}
                     errors={errors}
                     validationRules={{required: true, type: 'string'}}
                     register={register}/>
            </div>
            <div className="col_6">
              <Select
                label="Courier"
                name="courier_id"
                inline={true}
                options={couriers && couriers.data.length ? couriers.data : []}
                errors={errors}
                optionValue={'id'}
                optionLabel={'name'}
                validationRules={{required: true}}
                register={register}/>
            </div>
            <div className="col_6 pr_20">
              <Input label="Fees"
                     name="fee"
                     inline={true}
                     errors={errors}
                     validationRules={{required: true, type: 'double'}}
                     register={register}/>
            </div>
            <div className="col_6">
              <RadioBox label="Status"
                        name="status"
                        inline={true}
                        errors={errors}
                        options={[{id: "1", name: 'Active'}, {id: "0", name:"Inactive"}]}
                        validationRules={{required:true, type: 'string'}}
                        register={register}/>
            </div>
            <div className="col_6">
              <RadioBox label="Domestic?"
                        name="domestic"
                        inline={true}
                        errors={errors}
                        options={[{id: "1", name: 'Yes'}, {id: "0", name:"No"}]}
                        register={register}/>
            </div>
            <div className="col_6">
              <RadioBox label="International?"
                        name="international"
                        inline={true}
                        errors={errors}
                        options={[{id: "1", name: 'Yes'}, {id: "0", name:"No"}]}
                        register={register}/>
            </div>
          </div>

          <div className="d_flex_end">
            <Button
              text="save"
              isPending={isPending}
              type={"submit"}
            />
          </div>
        </form>
      </Modal>
    </>
  );
}

export default ShippingMethodFormComponent;